<template>
  <section class="container">
    <div class="order" v-for="(item, index) in orders" :key="index">
      <van-cell title="订单信息" size="large">
        <svg-icon slot="icon" class="order__icon" icon-class="我的订单" />
      </van-cell>
      <van-cell border size="large">
        <span slot="title">
          <van-row>
            <van-col span="6">订单编号</van-col>
            <van-col span="18" class="order__info">
              {{ item.outTradeNo.split('_')[0] }}
            </van-col>
          </van-row>
        </span>
      </van-cell>
      <van-cell border size="large">
        <span slot="title">
          <van-row>
            <van-col span="6">车牌号码</van-col>
            <van-col span="18" class="order__info">
              {{ item.cardNumber }}
            </van-col>
          </van-row>
        </span>
      </van-cell>
      <van-cell border size="large">
        <span slot="title">
          <van-row>
            <van-col span="6">车场名称</van-col>
            <van-col span="18" class="order__info">{{ item.parking }}</van-col>
          </van-row>
        </span>
      </van-cell>
      <van-cell border size="large">
        <span slot="title">
          <van-row>
            <van-col span="6">支付时间</van-col>
            <van-col span="18" class="order__info">
              {{ item.paidTime }}
            </van-col>
          </van-row>
        </span>
      </van-cell>
      <van-cell border size="large">
        <span slot="title">
          <van-row>
            <van-col span="6">支付金额</van-col>
            <van-col span="13" class="order__money">
              ¥
              {{ (item.paidMoney / 100).toFixed(2) }}
            </van-col>
            <van-col span="5" class="order__info">
              <van-button size="small" type="info" @click="submitInvoicing">
                开具发票
              </van-button>
            </van-col>
          </van-row>
        </span>
      </van-cell>
    </div>
  </section>
</template>

<script>
import { Row, Col, Icon, NoticeBar } from 'vant'
import { mapGetters } from 'vuex'
export default {
  props: {
    orders: {
      type: Array,
      default () {
        return {}
      }
    }
  },
  components: {
    [Row.name]: Row,
    [Col.name]: Col,
    [Icon.name]: Icon,
    [NoticeBar.name]: NoticeBar
  },
  computed: {
    ...mapGetters(['wx_userInfo', 'token'])
  },
  data () {
    return {
      showList: false
    }
  },
  methods: {
    submitInvoicing () {
      let _this = this
      _this.$toast('暂未开通 敬请期待！')
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  background: #f3f4f5;
  height: 100vh;

  .order {
    background: #ffffff;
    margin-bottom: 10px;

    &__icon {
      font-size: 20px;
      color: #4b62ec;
      line-height: 24px;
      margin-right: 8px;
      height: 24px;
    }

    &__id {
      color: #444444;
      font-size: 16px;
      padding: 12px 16px;
      border-bottom: 1px solid #f3f4f5;
      background: #fff;
    }

    /deep/ .van-cell__title {
      color: #444444;

      .order__info {
        font-size: 16px;
      }

      .order__money {
        font-size: 18px;
        color: #49a6ff;
      }
    }
  }
}
</style>